var map = {
	"./components/activos-fijos/activos-fijos.module": [
		"../../../../../src/app/components/activos-fijos/activos-fijos.module.ts",
		"activos-fijos.module"
	],
	"./components/bancos/bancos.module": [
		"../../../../../src/app/components/bancos/bancos.module.ts",
		"bancos.module",
		"common"
	],
	"./components/compras/compras.module": [
		"../../../../../src/app/components/compras/compras.module.ts"
	],
	"./components/configuracion/configuracion.module": [
		"../../../../../src/app/components/configuracion/configuracion.module.ts",
		"configuracion.module",
		"common"
	],
	"./components/consulta_compras/consulta-compras.module": [
		"../../../../../src/app/components/consulta_compras/consulta-compras.module.ts",
		"consulta-compras.module"
	],
	"./components/consulta_ventas/consulta-ventas.module": [
		"../../../../../src/app/components/consulta_ventas/consulta-ventas.module.ts",
		"consulta-ventas.module"
	],
	"./components/contabilidad/contabilidad.module": [
		"../../../../../src/app/components/contabilidad/contabilidad.module.ts",
		"contabilidad.module"
	],
	"./components/ecommerce/ecommerce.module": [
		"../../../../../src/app/components/ecommerce/ecommerce.module.ts",
		"ecommerce.module"
	],
	"./components/general/general.module": [
		"../../../../../src/app/components/general/general.module.ts",
		"general.module"
	],
	"./components/hotel/hotel.module": [
		"../../../../../src/app/components/hotel/hotel.module.ts",
		"hotel.module"
	],
	"./components/inventario/inventario.module": [
		"../../../../../src/app/components/inventario/inventario.module.ts",
		"inventario.module"
	],
	"./components/marketplace/marketplace.module": [
		"../../../../../src/app/components/marketplace/marketplace.module.ts",
		"marketplace.module",
		"common"
	],
	"./components/restaurante/restaurante.module": [
		"../../../../../src/app/components/restaurante/restaurante.module.ts",
		"restaurante.module"
	],
	"./components/seguridad/seguridad.module": [
		"../../../../../src/app/components/seguridad/seguridad.module.ts",
		"seguridad.module",
		"common"
	],
	"./components/tributacion-sri/tributacion-sri.module": [
		"../../../../../src/app/components/tributacion-sri/tributacion-sri.module.ts",
		"tributacion-sri.module"
	],
	"./components/ventas/ventas.module": [
		"../../../../../src/app/components/ventas/ventas.module.ts"
	],
	"./empresa-view/empresa-view.module": [
		"../../../../../src/app/components/general/empresa-view/empresa-view.module.ts",
		"empresa-view.module"
	]
};
function webpackAsyncContext(req) {
	var ids = map[req];
	if(!ids)
		return Promise.reject(new Error("Cannot find module '" + req + "'."));
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(function() {
		return __webpack_require__(ids[0]);
	});
};
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = "../../../../../src/$$_lazy_route_resource lazy recursive";
module.exports = webpackAsyncContext;


//////////////////
// WEBPACK FOOTER
// /var/www/nodejs/nextstore/src/$$_lazy_route_resource lazy
// module id = ../../../../../src/$$_lazy_route_resource lazy recursive
// module chunks = main